'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PlacementConstants = require('./PlacementConstants');

var _Placement = require('./utils/Placement');

var _sizes = require('HubStyleTokens/sizes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UIPopoverArrow = _react2.default.createClass({
  displayName: 'UIPopoverArrow',

  propTypes: {
    color: _react.PropTypes.string,
    inset: _react.PropTypes.number.isRequired,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    width: _react.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      inset: 0,
      placement: 'top',
      width: 20
    };
  },
  getStyles: function getStyles() {
    var _props = this.props,
        color = _props.color,
        inset = _props.inset,
        placement = _props.placement,
        width = _props.width;

    var styles = {
      backgroundColor: color,
      borderTopColor: 'transparent',
      borderLeftColor: 'transparent',
      width: width,
      height: width
    };

    switch ((0, _Placement.getSide)(placement)) {
      case 'top':
        // Arrow points down
        styles.transform = 'rotate(45deg)';
        styles.top = 'calc(100% - ' + width / 2 + 'px)';
        break;
      case 'right':
        // Arrow points left
        styles.transform = 'rotate(135deg)';
        styles.left = -(width / 2);
        break;
      case 'bottom':
        // Arrow points up
        styles.transform = 'rotate(-135deg)';
        styles.top = -(width / 2);
        break;
      case 'left':
        // Arrow points right
        styles.transform = 'rotate(-45deg)';
        styles.left = 'calc(100% - ' + width / 2 + 'px)';
        break;
      default:
        break;
    }

    // Magic calculation, haven't quite figured this out yet
    var adjustedInset = inset + 3;

    switch ((0, _Placement.getEdge)(placement)) {
      case 'top':
        // Arrow is near the bottom of the left or right side
        styles.bottom = adjustedInset;
        break;
      case 'middle':
        // Arrow is in the middle of the left or right side
        styles.top = 'calc(50% - ' + width / 2 + 'px)';
        break;
      case 'bottom':
        // Arrow is near the top of the left or right side
        styles.top = adjustedInset;
        break;
      case 'left':
        // Arrow is near the right of the top or bottom side
        styles.right = adjustedInset;
        break;
      case 'center':
        // Arrow is in the center of the top or bottom side
        styles.left = 'calc(50% - ' + width / 2 + 'px)';
        break;
      case 'right':
        // Arrow is near the left of the top or bottom side
        styles.left = adjustedInset;
        break;
      default:
        break;
    }

    return styles;
  },
  render: function render() {
    if (this.props.width === 0) {
      return null;
    }
    return _react2.default.createElement('div', {
      className: 'uiPopoverArrow private-popover__arrow',
      style: this.getStyles()
    });
  }
});

var mediumArrowSize = parseInt(_sizes.POPOVER_ARROW_SIZE, 10);
var smallArrowSize = parseInt(_sizes.TOOLTIP_ARROW_SIZE, 10);

UIPopoverArrow.ARROW_SIZES = {
  none: {
    distance: 4,
    inset: 0,
    width: 0
  },
  medium: {
    distance: mediumArrowSize,
    inset: mediumArrowSize - 2,
    width: 20
  },
  small: {
    distance: smallArrowSize,
    inset: smallArrowSize - 2,
    width: 16
  }
};

exports.default = UIPopoverArrow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/tooltip/UIPopoverArrow.js
// module id = 85
// module chunks = 0